// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__vOtA5","tab":"styles_tab__2Tgwx","active-tab":"styles_active-tab__Pvy6O"};